var render, staticRenderFns
import script from "./MarkdownView.vue?vue&type=script&lang=ts&"
export * from "./MarkdownView.vue?vue&type=script&lang=ts&"
import style0 from "./MarkdownView.vue?vue&type=style&index=0&id=7598c020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7598c020",
  null
  
)

export default component.exports